import cityRegionData from "@utils/CityRegionData";
import { useCallback } from "react";

export default function useCityRegionCode() {
  const cityNameList = Object.keys(cityRegionData);
  type GetPostCodeWithCVS = {
    code: string;
    city: string;
    town: string;
    address: string;
  };

  /**
   * @param address 完整地址
   * @param lastNumber 縣市+鄉鎮名稱長度
   * @returns
   */
  const getPostCodeWithCVS = useCallback((address: string, lastNumber?: number): GetPostCodeWithCVS => {
    if (!address || Object.keys(cityRegionData).length === 0 || (lastNumber && lastNumber > 7) || address.length <= 6) {
      // lastNumber > 7 等於鄉鎮名稱超過 5 個字，台灣沒這種地方
      // 有可能是資料有漏需要更新
      return { code: "", city: "", town: "", address: address || "" };
    }
    // 統一用「臺」，避免「台」造成查表失敗
    const normalizedAddress = address.replace(/台/g, "臺");
    const last = lastNumber || 5;
    const city = normalizedAddress.slice(0, 3);
    // 擷取鄉鎮預設選地址的第 4~5 元素 e.g. 台中市東區
    // 若比對縣市列表有找到相對應的 zipCode 則 return code, city......等資料
    // 若比對不成則將 last + 1 改取地址的第 4~6 元素 e.g. 台北市信義區
    const town = normalizedAddress.slice(3, last);

    if (cityRegionData[city] && cityRegionData[city][town]) {
      return {
        code: String(cityRegionData[city][town]),
        city,
        town,
        // 為方便物流更直覺的辨識地址，路名以下（含）維持原輸入者輸入的『台』或『臺』
        address: address.slice(last),
      };
    }

    return getPostCodeWithCVS(address, last + 1);
  }, []);

  return {
    getPostCodeWithCVS,
    allCities: cityRegionData,
    cityNameList,
    cityNameOptions: cityNameList.map((city) => ({ label: city, value: city })),
    getCityRegion: (city: string) => cityRegionData[city],
    getCityRegionOptions: (city: string) =>
      Object.entries(cityRegionData[city]).map((key) => ({ label: key[0], value: key[0], key: key[1] })),
  };
}
